import React, { forwardRef } from 'react';

// Using React.SVGProps<SVGSVGElement> to allow all native SVG attributes,
// plus custom optional props for size, color, and title for convenience.
export interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string; // Overrides inherited currentColor if provided
  size?: string | number;
  title?: string;
}

const FunctionPython = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size = 20, title, className, style, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        // The default SVG attributes (fill, stroke, strokeWidth, etc.) 
        // are REMOVED here so the raw SVG paths determine the appearance.
        className={className}
        style={color ? { color, ...style } : style} // Apply color via CSS property for inheritance if set
        {...props}
      >
        {/* If the original SVG has complex colors/fills, we want them here. */}
        {title && <title>{title}</title>}
        <g clipPath="url(#clip0_1534_28977)">
                                  <path d="M15.25 8V2.25C15.25 1.42157 14.5784 0.75 13.75 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V13.75C0.75 14.5784 1.42157 15.25 2.25 15.25H8" stroke="currentColor"  strokeWidth="1.5"></path>
                                  <path d="M9.24618 4.25V4.25C8.00565 4.25 7 5.25565 7 6.49618L7 9.50439C7 10.7446 5.99461 11.75 4.75439 11.75V11.75" stroke="currentColor"  strokeWidth="1.5" strokeLinecap="square"></path>
                                  <path d="M5.25 7.75H8.75" stroke="currentColor"  strokeWidth="1.5" strokeLinecap="square"></path>
                                  <path d="M14 15C14 15.5523 13.5523 16 13 16L12.5 16C11.9477 16 11.5 15.5523 11.5 15L11.5 13.5C11.5 12.9477 11.9477 12.5 12.5 12.5C13.0523 12.5 13.5 12.0523 13.5 11.5L13.5 11L14.25 11C15.2165 11 16 11.7835 16 12.75C16 13.7165 15.2165 14.5 14.25 14.5L14 14.5L14 15Z" fill="#FFC700" ></path>
                                  <path d="M11 10C11 9.44772 11.4477 9 12 9H12.5C13.0523 9 13.5 9.44772 13.5 10V11.5C13.5 12.0523 13.0523 12.5 12.5 12.5C11.9477 12.5 11.5 12.9477 11.5 13.5V14H10.75C9.7835 14 9 13.2165 9 12.25C9 11.2835 9.7835 10.5 10.75 10.5H11V10Z" fill="#338ED8" ></path>
                                </g>
      </svg>
    );
  }
);

FunctionPython.displayName = 'FunctionPython';

export default FunctionPython;
